import { getEnvConfig } from "../utils"

export const MAIN_PRIMARY_COLOR = process.env.RAZZLE_MAIN_PRIMARY_COLOR || '#FF5757'
export const CONTRAST_TEXT_FOR_PRIMARY_COLOR = process.env.RAZZLE_CONTRAST_TEXT_FOR_PRIMARY_COLOR || '#ffffff'
export const MAIN_SECONDARY_COLOR = process.env.RAZZLE_MAIN_SECONDARY_COLOR || '#3D7B6C'
export const CONTRAST_TEXT_FOR_SECONDARY_COLOR = process.env.RAZZLE_CONTRAST_TEXT_FOR_SECONDARY_COLOR || '#ffffff'
export const STATIC_PATH = `${process.env.PUBLIC_PATH}${ process.env.NODE_ENV === 'development' ? 'static/' : '_razzle/static/' }`
// senty for bug tracking
export const SENTRY_DSN = process.env.RAZZLE_SENTRY_DSN

export const BASE_URL = process.env.RAZZLE_BASE_URL

export const WEB_SITE_NAME = process.env.RAZZLE_WEB_SITE_NAME
export const SEO_DEFAULT_IMAGE = process.env.RAZZLE_SEO_DEFAULT_IMAGE
export const AUTH_TOKEN = process.env.RAZZLE_AUTH_TOKEN